const actions = {
    PRODUCT_DASHBOARD_START: 'PRODUCT_DASHBOARD_START',
    PRODUCT_DASHBOARD_SUCCESS: 'PRODUCT_DASHBOARD_SUCCESS',
    PRODUCT_DASHBOARD_FAILURE: 'PRODUCT_DASHBOARD_FAILURE',

    PRODUCT_WISE_ANALYSIS_START: 'PRODUCT_WISE_ANALYSIS_START',
    PRODUCT_WISE_ANALYSIS_SUCCESS: 'PRODUCT_WISE_ANALYSIS_SUCCESS',
    PRODUCT_WISE_ANALYSIS_FAILURE: 'PRODUCT_WISE_ANALYSIS_FAILURE',
};

export default actions;